import { useLocation } from "react-router-dom";

function useSearch() {
  return new URLSearchParams(useLocation().search);
}

export default useSearch;
